<template>
    <div class='success-background'>
        <div 
            class="success-page"
            ref="submitPopupRef"
        >         
          <!--shading="true"
            shading-color="white"-->
        <div class="success-text">
          <div class="center-text submit-success success-bold">{{this.$route.params.firstName}} {{this.$route.params.lastName}}</div>
          <div class="center-text submit-success">checked into</div>
          <div class="center-text submit-success success-bold">{{this.$route.params.accountName}} </div>
          <div class="center-text submit-success">on {{new Date().toLocaleDateString()}} with DineSafeVT</div>
        </div>
          <!--<div class="center-text submit-success safe-dining">Safe Dining!</div>-->          

          <div v-if="false" class="center-text review-info-link">
            <router-link 
              :to="{ path: 'edit-user-account' }"
            >
              Click to review your profile
            </router-link>
          </div>

          <div class="success-menu-button center">
          <DxButton v-if="this.$route.params.menuURL != '' || this.menuURL != ''"
            ref="btnMenuRef" 
            :width="160" 
            type="default"
            icon="food"
            text="View Menu"
            styling-mode="contained" 
            :visible="true"
            @click="btnViewMenuClick"
          />
          </div>

          <div class="success-profile-button center">
          <DxButton 
            ref="btnEditProfileRef" 
            :width="160" 
            type="default"
            icon="user"
            text="Edit Profile"
            styling-mode="contained" 
            :visible="true"
            @click="btnEditProfileClick"
          />
          </div>

          <DxButton v-if="false"
            ref="CheckRef" 
            :width="100" 
            :height="100"
            type="normal"
            icon="check"
            text=""
            styling-mode="text" 
            :visible="true"
            @click="onCheckClick"
          />

          <div v-if="false" class="microsite-container center-text">
            <div class="microsite-text">
              <img class="small-logo" src='../assets/DineSafeSquare.png'/>
            </div>
            <div class='microsite-link'>
              <a src='../assets/csl-star.png' href='https://www.dinesafevt.co/benefit-for-the-diner'>Learn about DineSafeVT</a>
            </div>
          </div>

          <div class="microsite-container center-text">
            <div class="microsite-text">
              <img class="small-logo" src='../assets/DineSafeSquare.png'/>
            </div>
            <div class='microsite-link'>
              <a src='../assets/csl-star.png' href='https://www.dinesafevt.co/benefit-for-the-diner'>Learn about DineSafeVT</a>
            </div>
          </div>
          
        </div>
    </div>
</template>

<script>
    import {DxButton} from 'devextreme-vue';
    import notify from 'devextreme/ui/notify';

    export default {
        components: {
            DxButton,
        },
        props: {
          firstName: String,
          lastName: String,
          accountName: String,
          menuURL: String,
        },
        data(){
            return{
                submitted: true,
            }
        },
        created(){
          //Check if the AccountName has a value.  If it does not, someone navigated to this page directly without scanning a barcode. 
          //So, push them to the QR Scanner page, and show a message that reads "No Cheating"

          if(this.$route.params.accountName == '' || this.$route.params.accountName == null)
          {
            /*notify(
              {
                  message: "No cheating", 
                  type:"error", 
                  width:100, 
                  displayTime: 2000,
                  position: {
                    my: 'center center',
                    at: 'center center',
                  }
              });*/

            this.$router.push("/home");
          }
        },
        methods:{
            onCheckClick(e){
                console.log("checkClick");

                //Hide the popup if you weren't automatically logged-in
                this.submitted=false;
            },
            btnViewMenuClick(e){
              window.location.href=this.$route.params.menuURL;
            },
            btnEditProfileClick(e){
              this.$router.push("/edit-user-account");
            },
            reviewInfoClick(){
                console.log("reviewInfoClick");
            }
        }
    }
</script>

<style>
  @import '../themes/contact-tracing.css';

  /* Center everything horizontally */
  .success-page{
    /*margin: 0;*/
    margin: auto;
    display: table;
    height: auto;

    /* top: 50%; */
    /*left:50%;
    -ms-transform: translate(-50%);
    transform: translate(-50%);
    /* transform: translate(-50%, -50%); */
    /*position: absolute;*/
  }

  .review-info-link{
    padding-bottom: 20px;
  }

  .success-bold{
    font-weight: bold;
    font-size: 140%;
  }

  .success-menu-button, .success-profile-button{
    padding:10px;
  }

  /* Set the background color of the Menu button on this page */
  .success-menu-button > .dx-button.dx-button-default{
    background-color: #BB764C;
  }

  /* Set the background color of the Profile button on this page */
  .success-profile-button > .dx-button.dx-button-default{
    background-color: #572D43;
  }

  .success-text{
    background-color: #d9e0d8;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 10px;
    box-shadow:0 1px 3px #572D43
  }

</style>
